import { render, staticRenderFns } from "./ModalSparkle.vue?vue&type=template&id=df5bcb8c&scoped=true&"
import script from "./ModalSparkle.vue?vue&type=script&lang=js&"
export * from "./ModalSparkle.vue?vue&type=script&lang=js&"
import style0 from "./ModalSparkle.vue?vue&type=style&index=0&id=df5bcb8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5bcb8c",
  null
  
)

component.options.__file = "ModalSparkle.vue"
export default component.exports